import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import lodash from 'lodash';
import './play-action-tracker.css';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

function PlayActionTracker({ socket, deviceId }) {
  const { playActionData, prevPlayActionData } = useSelector((state) => state.deviceDetails);
  const [blink, setBlink] = useState(false);
  let lastRequestTime = 0;

  useEffect(() => {
    setBlink(true);
    setTimeout(() => setBlink(false), 1000); // Remove blink class after animation
  }, [playActionData]);

  const sendLogFileMarkerRequest = useCallback(async () => {
    if (socket && socket.connected) {
      const currentTime = Date.now();
      if (currentTime - lastRequestTime >= 5000) { // 5 seconds gap
        await socket.emit('add_debug_marker_in_logs', { deviceId, timestamp: dayjs.utc().unix() });
        lastRequestTime = currentTime;
      } else {
        console.log('Request ignored due to debounce mechanism');
      }
    } else {
      window.alert('Socket not connected');
    }
  }, [socket, deviceId]);

  /* const sendNextDeliveryPattern = useCallback(async () => {
    const getRandomValue = () => {
      const values = [11, 12, 13, 14, 15, 16];
      return values[Math.floor(Math.random() * values.length)];
    };

    if (socket && socket.connected) {
      const currentTime = Date.now();
      if (currentTime - lastRequestTime >= 3000) { // 3 seconds gap
        const randomValue = getRandomValue();
        await socket.emit('send_forced_next_delivery_pattern',
          { deviceId, pattern: `BLOCK_${randomValue}_TOP_SPIN_L3`, timestamp: dayjs.utc().unix() });
        lastRequestTime = currentTime;
      } else {
        console.log('Request ignored due to debounce mechanism');
      }
    } else {
      window.alert('Socket not connected');
    }
  }, [socket, deviceId]); */

  const formatPropertyName = (text) => {
    const mapping = {
      currentBlockId: 'Current Block Id',
      mappedBlockId: 'Mapped Block Id',
      nextDeliveryPattern: 'Next Delivery Pattern',
      ballDeliverySerialNumber: 'Ball Delivery Serial Number',
      payloadDeviceId: 'Device Id',
      currentSessionId: 'Session Id',
    };

    return mapping[text] || text;
  };

  return (
    <Grid container spacing={2}>
      <Grid item size={12}>
        <Stack direction="row" spacing={2} justifyContent="flex-end" marginBottom={2}>
          <Button variant="contained" color="primary" onClick={sendLogFileMarkerRequest}>
            {'Send log marker request'}
          </Button>
          {/* <Button variant="contained" color="primary" onClick={sendNextDeliveryPattern}>
            {'Send next delivery pattern'}
          </Button> */}
        </Stack>
      </Grid>
      <Grid item size={12}>
        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Box width="50%">
            {
              !playActionData ||
              Object.keys(playActionData).length === 0 ||
              lodash.get(playActionData, 'currentSessionId', '').includes('-') ? (
                <Typography variant="h4">{'No active playing session'}</Typography>
                  ) : null
            }
          </Box>
        </Stack>
      </Grid>
      {
        playActionData &&
        Object.keys(playActionData).length > 0 &&
        !lodash.get(playActionData, 'currentSessionId', '').includes('-') ? (
          <>
            <Grid item size={12}>
              <Typography variant="h6">Play Action Tracker</Typography>
            </Grid>
            <Grid item size={12}>
              <Card
                sx={{ minWidth: 275 }}
                variant="outlined"
                className={blink ? 'blink' : ''}
              >
                <CardContent>
                  <Typography variant="h5" component="div" color="primary" marginBottom={2}>
                    {'Current Delivery'}
                  </Typography>
                  {
                    Object.keys(playActionData).map((key) => (
                      <Box sx={{ flexGrow: 1, marginY: '0.5rem' }} key={key}>
                        <Grid container sx={{ marginBottom: '1rem' }}>
                          <Grid item size={6}>
                            <Typography sx={{ fontWeight: 'bold', fontSize: '1rem' }}>
                              {formatPropertyName(key)}
                            </Typography>
                          </Grid>
                          <Grid item size={6}>
                            <Typography sx={{ fontSize: '1.25rem' }}>
                              {playActionData[key]}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    ))
                  }
                </CardContent>
              </Card>
              {
                Object.keys(prevPlayActionData).length > 0 ? (
                  <Card
                    sx={{ minWidth: 275, marginTop: '1rem' }}
                    variant="outlined"
                  >
                    <CardContent>
                      <Typography variant="h5" component="div" color="primary" marginBottom={2}>
                        {'Previous Delivery'}
                      </Typography>
                      {
                        Object.keys(prevPlayActionData).map((key) => (
                          <Box sx={{ flexGrow: 1, marginY: '0.5rem' }} key={key}>
                            <Grid container spacing={2}>
                              <Grid item size={6}>
                                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                  {formatPropertyName(key)}
                                </Typography>
                              </Grid>
                              <Grid item size={6}>
                                <Typography variant="body1">
                                  {playActionData[key]}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Box>
                        ))
                      }
                    </CardContent>
                  </Card>
                ) : null
              }
            </Grid>
          </>
            ) : null
      }

      <Grid item xs={12}>
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', marginY: '2rem' }}>

        </Box>
      </Grid>
    </Grid>
  );
}

PlayActionTracker.propTypes = {
  socket: PropTypes.object.isRequired,
  deviceId: PropTypes.string.isRequired,
};

export default React.memo(PlayActionTracker);
